import { useStore } from 'hooks/useStore';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useRef, useState } from 'react';

export const useNDCListComponent = () => {
  const op = useRef<OverlayPanel | null>(null);
  const {
    DrugPortfolioManagementStore: { saveGFCStatus, saveDrugStatus },
  } = useStore();
  const [selectedID, setSelectedID] = useState<number>(0);
  const [selectedGfc, setSelectedGfc] = useState<number>(0);
  const [selectedNdc, setSelectedNdc] = useState<string>('');
  const [gfcToggleClicked, setgfcToggleClicked] = useState<boolean>(false);
  const [gfcUpdate, setGFCUpdate] = useState<number>(0);

  const handleToggleClick = (e: React.MouseEvent, id: number, gfc: number, ndc: string) => {
    // Ensure we are in single-item mode
    setgfcToggleClicked(false);
    setGFCUpdate(0);
    if (op.current) {
      (op.current as any).show(e);
      setSelectedID(id);
      setSelectedGfc(gfc);
      setSelectedNdc(ndc);
    }
  };

  const handleGFCtoggleClick = (e: React.MouseEvent, gfc: number) => {
    // Enter group (GFC-level) mode explicitly
    setgfcToggleClicked(true);
    setSelectedID(0);
    setSelectedNdc('');
    if (op.current) {
      (op.current as any).show(e);
      setGFCUpdate(gfc);
    }
  };

  const handleGFCUpdate = async (e: React.MouseEvent, source: string, destination: string) => {
    if (gfcUpdate != 0) {
      // Close immediately, then process async
      if (op.current) (op.current as any).hide();
      await saveGFCStatus(gfcUpdate, source, destination);
      setgfcToggleClicked(false);
    }
  };

  const handleUpdate = (e: React.MouseEvent, source: string, destination: string) => {
    if (selectedID !== 0) {
      // Close immediately, then process async
      if (op.current) (op.current as any).hide();
      saveDrugStatus(selectedID, selectedNdc, selectedGfc, source, destination);
    } else {
      setSelectedID(0);
      setSelectedGfc(0);
      setSelectedNdc('');
    }
  };

  return {
    op,
    gfcToggleClicked,
    handleToggleClick,
    handleUpdate,
    handleGFCUpdate,
    handleGFCtoggleClick,
  };
};
